'use strict';
// TODO: Remove from `core-js@4`
require('../modules/es.map.group-by');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/esnext.map.group-by.js
// module id = 1478
// module chunks = 0